import { db } from '../firebase';
import { collection, query, where, getDocs, addDoc, updateDoc, doc, arrayUnion } from 'firebase/firestore';
import { invalidateCollection } from '../hooks/useCachedCollection';

/**
 * Checks if a brand exists in the 'brands' collection.
 * If not, adds it with the given model.
 * If yes, adds the model to the 'models' array if not already present.
 * 
 * @param {string} brandName - The name of the brand
 * @param {string} modelName - The name of the model
 */
export const syncBrandAndModel = async (brandName, modelName) => {
    if (!brandName || !modelName) return;

    try {
        const brandsRef = collection(db, 'brands');
        // Simple case-insensitive check could be expensive with many brands, 
        // but robust. For now, trusting exact match or simple query.
        // Since Firestore is case-sensitive, we'll try to match exact first.

        // Fetch all brands to find case-insensitive match (safe for small dataset)
        // Optimization: Create a 'normalizedName' field in future.
        const querySnapshot = await getDocs(brandsRef);
        let existingBrandDoc = null;

        querySnapshot.forEach(doc => {
            if (doc.data().name.toLowerCase() === brandName.trim().toLowerCase()) {
                existingBrandDoc = doc;
            }
        });

        if (existingBrandDoc) {
            // Brand exists, check model
            const currentModels = existingBrandDoc.data().models || [];
            const modelExists = currentModels.some(m => m.model.toLowerCase() === modelName.trim().toLowerCase());

            if (!modelExists) {
                await updateDoc(doc(db, 'brands', existingBrandDoc.id), {
                    models: arrayUnion({ model: modelName.trim() })
                });
                // Marka listesi oturum cache'inden okunuyor; yeni model anında görünsün.
                invalidateCollection('brands');
                console.log(`Model '${modelName}' added to existing brand '${brandName}'.`);
            }
        } else {
            // Brand does not exist, create it
            await addDoc(brandsRef, {
                name: brandName.trim(),
                models: [{ model: modelName.trim() }]
            });
            // Marka listesi oturum cache'inden okunuyor; yeni marka anında görünsün.
            invalidateCollection('brands');
            console.log(`New brand '${brandName}' created with model '${modelName}'.`);
        }
    } catch (error) {
        console.error("Error syncing brand/model:", error);
    }
};
